import {Box, Text} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {LuOctagonAlert} from 'react-icons/lu'

export function OutOfStockAlert({
  outOfStockItems,
  missingTradeNames,
  isSolvent,
  notEnoughAmount,
  inactiveTradeName,
}: {
  outOfStockItems: string[]
  missingTradeNames?: string[]
  isSolvent?: boolean
  notEnoughAmount?: boolean
  /** the items' trade names are inactive in the catalogue, so no stock can be added (CY-259) */
  inactiveTradeName?: boolean
}) {
  const {t} = useTranslate('common')
  return (
    <Box
      key={outOfStockItems.join(', ')}
      bgColor={'red.muted'}
      display={'flex'}
      padding="4"
      gap="3"
      width={'100%'}
      colorPalette={'orange.fg'}
      borderRadius="md"
    >
      <Box colorPalette={'orange.fg'}>
        <LuOctagonAlert size="18" color="#92310A" />
      </Box>
      <Box>
        <Text fontWeight={'medium'} color="orange.fg">
          {inactiveTradeName
            ? t('trade_name_inactive.title', 'Trade name inactive')
            : notEnoughAmount
              ? t('insufficient_amount')
              : t('insufficient_stock')}
        </Text>
        <Text fontSize="sm" color="orange.fg" fontWeight={'normal'}>
          {inactiveTradeName
            ? t(
                'trade_name_inactive.picking_list',
                '{items} is inactive in the catalogue. Choose an active trade name on the prescription.',
                {items: outOfStockItems.join(', ')}
              )
            : isSolvent
              ? t('solvents_lack_inventory', {items: outOfStockItems.join(', ')})
              : t('items_lack_inventory', {items: outOfStockItems.join(', ')})}
        </Text>
        {missingTradeNames && missingTradeNames.length > 0 && (
          <Text fontSize="sm" color="orange.fg" fontWeight={'normal'}>
            {t('solvents_missing_trade_name', 'No trade name exists for {items}.', {
              items: missingTradeNames.join(', '),
            })}
          </Text>
        )}
      </Box>
    </Box>
  )
}
